import { useEffect } from 'react'

interface ModalProps {
  open: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  size?: 'sm' | 'md' | 'lg' | 'xl'
  // false = so fecha no X / botoes (clicar fora nao fecha; evita perder o que estava preenchendo)
  fecharAoClicarFora?: boolean
}

export function Modal({ open, onClose, title, children, size = 'md', fecharAoClicarFora = true }: ModalProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => { document.body.style.overflow = '' }
  }, [open])

  if (!open) return null

  const maxW = size === 'sm' ? 'max-w-sm' : size === 'lg' ? 'max-w-2xl' : size === 'xl' ? 'max-w-4xl' : 'max-w-lg'

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={fecharAoClicarFora ? onClose : undefined} />
      <div className={`relative bg-compumaq-pretoSuave border border-compumaq-dourado/25 rounded-xl shadow-xl w-full ${maxW} max-h-[90vh] overflow-y-auto`}>
        <div className="flex items-center justify-between p-6 border-b border-compumaq-dourado/25">
          <h2 className="text-lg font-semibold text-compumaq-texto">{title}</h2>
          <button
            onClick={onClose}
            className="text-compumaq-textoSuave hover:text-compumaq-texto transition-colors p-1 rounded"
          >
            ✕
          </button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  )
}
